// This file is AUTOGENERATED, do not edit it manually!!!

export const menu = {
    dashboard: 'Tablica rozdzielcza',
    notifications: 'Ustawienia powiadomień',
    portfolios: 'Portfele',
    reports: 'Raporty',
    resourcesPage: 'Środki',
    roles: 'Role',
    search: 'Poszukiwanie',
    updateLicense: 'Aktualizuj licencję',
};
